import { FormControl, StyledInput } from "../../Form/FormControls";

const SearchInput = ({
  label,
  placeholder,
  inputText,
  handleChange,
  warning,
}) => (
  <FormControl style={{ maxWidth: "300px" }}>
    {warning && (
      <div
        style={{ marginBottom: "2px", color: "#cc3300", fontSize: "0.9rem" }}
      >
        Please enter at least 2 characters to search.
      </div>
    )}
    <StyledInput
      type="text"
      name={label}
      label={label}
      value={inputText}
      placeholder={placeholder}
      onChange={(e) => handleChange(e.target.value, e)}
    />
  </FormControl>
);

export default SearchInput;
